import { render, staticRenderFns } from "./common-layout.vue?vue&type=template&id=7dc86405&"
import script from "./common-layout.vue?vue&type=script&lang=js&"
export * from "./common-layout.vue?vue&type=script&lang=js&"
import style0 from "./common-layout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports